@file:UseSerializers(BigDecimalSerializer::class)
@file:Suppress("unused")

package net.sergeych.ugdx.shared.api

import kotlinx.serialization.Serializable
import kotlinx.serialization.UseSerializers
import net.sergeych.kiloparsec.command
import net.sergeych.ugdx.shared.BigDecimalSerializer
import net.sergeych.ugdx.shared.OrderRecord

@Serializable
class SubmitOrderArgs(val signedOrder:UByteArray)
val cmdSubmitOrder by command<SubmitOrderArgs,OrderRecord>()

@Serializable
class OrderIdArgs(val orderId: Long)
val cmdGetOrder by command<OrderIdArgs,OrderRecord>()

@Serializable
class OrderListArgs(val earlierThanId: String?=null,val maxSize: Int=50)

@Serializable
class OrderListResult(val orders: List<OrderRecord>, val hasMore: Boolean)
val cmdListOrders by command<OrderListArgs,OrderListResult>()


